import { PermissionKey, useGetUserPermissionsSpacesByIdQuery } from '@client/api';

interface UseSpacePermissionsProps {
  id?: string;
}

export function useSpacePermissions({ id }: UseSpacePermissionsProps) {
  const { data, error, isError, isLoading } = useGetUserPermissionsSpacesByIdQuery(
    {
      id: id ?? '',
    },
    {
      skip: !id,
    },
  );
  return {
    data,
    error,
    isError,
    isLoading,
    hasPermission: (permissions: PermissionKey[]) => {
      if (!data?.permissions?.length) return false;
      return permissions.every((permission) => data.permissions.includes(permission));
    },
    hasAnyPermission: (permissions: PermissionKey[]) => {
      if (!data?.permissions?.length) return false;
      return permissions.some((permission) => data.permissions.includes(permission));
    },
  };
}
